<template>
  <v-radio-group
    class="d-flex ma-0 pa-0"
    v-model="modelValue"
    :row="!vertical"
    dense
    :rules="rules"
    hide-details="auto"
    :disabled="disabled"
    :hint="hint"
    color="primary"
    :persistent-hint="showHint"
    :class="{ 'radio-group-grid': grid }"
  >
    <v-radio v-for="(value, label) in options" color="primary" :key="label" :label="label" :value="value" />
  </v-radio-group>
</template>

<script>
import { PropOptions, ComputedOptions } from 'vue'
import { ValidationFunction } from '@/plugins/validation'

export default {
  name: 'RadioComponent',
  props: {
    value: {
      type: [String, Number, Boolean],
      default: null,
      validator: (v) => ['string', 'number', 'boolean'].includes(typeof v) || p === null,
    },
    /** @type {PropOptions<Record<string, string | number | boolean>>} */
    options: {
      type: Object,
      required: true,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    /** @type {PropOptions<ValidationFunction[]>} */
    rules: {
      type: [Array],
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: null,
    },
    grid: {
      type: Boolean,
      default: false,
    },
    hintCondition: {
      type: Object,
      default: () => {
      },
    },
  },
  computed: {
    /** @type {ComputedOptions<string | number | boolean>} */
    modelValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    showHint() {
      if (this.hintCondition) {
        const { condition, value } = this.hintCondition
        let show = false
        switch (condition) {
          case 'IS':
            show = this.modelValue === value
            break
          default:
            break
        }
        return !!this.hint && show
      }
      return !!this.hint
    },
  },
}
</script>

<style scoped>
.radio-group-grid :deep(.v-input--radio-group__input) {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

:deep(.v-label) {
  font-size: 14px;
}

:deep(.v-input--radio-group__input) {
  row-gap: 8px;
  column-gap: 24px;
}

:deep(label.v-label) {
  color: var(--v-neutralLighten17-base);
}
</style>
